import type { EventData } from '../types';

/**
 * Public web origin for /clip/join links — matches `getShareBaseUrl` in
 * `src/utils/shareEvent.ts` (prod vs dev) without Redux.
 */
export function getWebBaseUrl(): string {
  if (typeof window === 'undefined') return 'https://meeteor.me';
  const h = window.location.hostname;
  if (
    h === 'localhost' ||
    h.startsWith('127.') ||
    h.includes('dev.meeteor') ||
    h.includes('widget-dev') ||
    (h.includes('dev') && h.includes('meeteor'))
  ) {
    return 'https://dev.meeteor.me';
  }
  return 'https://meeteor.me';
}

/**
 * Same as main app `getEventShareUrl` — App Clip + universal link target.
 * Uses event_id, then slug, then _id (see `EventQRCodeModal` + `shareEvent.ts`).
 */
export function getEventShareUrl(event: Pick<EventData, 'event_id' | 'slug' | '_id'> | null | undefined): string {
  const baseUrl = getWebBaseUrl();
  if (!event) return baseUrl;
  const segment = event.event_id || event.slug || event._id || '';
  const id = String(segment || '').trim();
  if (!id) return baseUrl;
  return `${baseUrl}/clip/join?eventId=${encodeURIComponent(id)}`;
}

export function getWidgetEventOpenUrl(
  event: Pick<EventData, 'event_id' | 'slug' | '_id'> | null | undefined,
  refCode?: string,
): string {
  let url = getEventShareUrl(event);
  if (refCode?.trim() && url.includes('eventId=') && !url.includes('ref=')) {
    url = `${url}&ref=${encodeURIComponent(refCode.trim())}`;
  }
  return url;
}
